<template>
  <div>

    <FilterOrganization :disable="true" @option="onOptionChange" :option="option" :is-year="false" :is-department="isDepartment"/>

    <CRow class="mb-3">
      <CCol>
        <Timeline :isCard="true" caption="Competency" icon="cil-bookmark"/>
      </CCol>
    </CRow>

    <CRow>
      <CCol>
        <TimelineDanger :isCard="true" caption="Individual Development Plan" icon="cil-badge"/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Timeline from "@/projects/views/E-Performances/Dashboard/users/timeline.vue";
import TimelineDanger from "@/projects/views/E-Performances/Dashboard/users/timeline_danger.vue";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization.vue";

export default {
  name: "Dashboard",
  components: {FilterOrganization, Timeline, TimelineDanger},
  props: {
    caption: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "cil-layers"
    }
  },
  data: function () {
    return {

      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: "00000000000000000000000",
        year: new Date().getFullYear() + 543,
      },

      isDepartment: false,

    }

  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();

    },

    onLoad(){
      switch(this.$store.getters['personal/profile'].role){
        case 0:
          this.isDepartment = true;
          break;
        case 1:
          this.isDepartment = false;
          break;
        case 2:
          this.isDepartment = true;
          break;
      }
    },

    onOptionChange(e){
      this.option = e;
    },


  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
      profile: "personal/profile"

    }),
  },

  watch: {
    lang(value){
    },

    profile(value){
      this.onLoad();
    }
  }

}
</script>

<style scoped>

</style>
